import React from "react";
import MainViewLayout from "../layout/MainViewLayout";

export default function Orders() {
  return (
    <MainViewLayout>
      <h2>Orders</h2>
      <p>You will see order list in this page.</p>
    </MainViewLayout>
  );
}
